"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderTable = RenderTable;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const helpers_1 = require("../../TableCore/helpers");
const TableCore_1 = require("../../TableCore/TableCore");
const TableBusinessRules_1 = require("../TableBusinessRules");
function RenderTable(data, element) {
    const tableData = (0, TableBusinessRules_1.applyBusinessLogicOnTableColumns)(data);
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(TableCore_1.TableCore, Object.assign({}, tableData, { filterItems: (0, helpers_1.getUniqueItems)(tableData), rows: tableData.rows, expandableWrapperClassName: ".table-wrap", tableWrapperClassName: "table-wrapper flex w-full justify-center flex-wrap mb-12" })), element);
}
